import React, { InputHTMLAttributes, useEffect, useRef } from "react";

import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import Select from "@CheckoutOnepageOffers/components/atoms/Select";
import { useCheckoutOnepageOffersContext } from "@CheckoutOnepageOffers/provider/useCheckoutOnepageOffersContext";
import { useCheckoutContext } from "@payment/providers/CheckoutProvider/useCheckoutContext";
import { getInstallmentsCheckoutOnePage } from "@payment/utils/getInstallment";

import {
  DisabledText,
  InputContainer,
  InputContent,
  Label,
  RadioInput,
  WrapperInputs,
} from "./styles";

interface IInputStyledProps extends InputHTMLAttributes<HTMLInputElement> {
  name: string;
  mobile?: boolean;
  label: React.ReactNode;
  button?: React.ReactNode;
}

const RadioCreditCard = ({
  id,
  name,
  label,
  button,
  mobile,
  checked,
  disabled,
  ...rest
}: IInputStyledProps) => {
  const { state } = useGlobalContext();
  const { country } = useCheckoutContext();

  const { offer, checkoutOnePageDispatch, installments } =
    useCheckoutOnepageOffersContext();

  const radioRef = useRef<HTMLInputElement>(null);

  const onClickContainer = () => {
    radioRef.current.click();
  };

  const selectInstallment = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.currentTarget.value;

    checkoutOnePageDispatch({
      type: "SET_CHECKOUT_ONE_PAGE_SETTINGS",
      payload: {
        installmentSelected: value,
      },
    });
  };

  const installmentsOptions = getInstallmentsCheckoutOnePage(installments);

  const acquirer = state?.tenancy?.acquirer;
  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0].value < acquirer?.min_value;

  const defaultValueSelectInstallment = Number(offer?.offer?.max_installments);

  return (
    <InputContainer
      mobile={mobile}
      disabled={disabled}
      onClick={onClickContainer}
      checked={checked}
    >
      <InputContent>
        <RadioInput
          id={id}
          name={name}
          type="radio"
          ref={radioRef}
          checked={checked}
          disabled={disabled}
          {...rest}
        />
        <Label htmlFor={id}>{label}</Label>

        {disabled && !mobile && (
          <DisabledText>Temporariamente indisponível</DisabledText>
        )}

        {!!button && !disabled && button}
      </InputContent>

      {radioRef.current?.checked &&
        offer?.installments?.length &&
        !IS_MIN_VALUE &&
        installments?.length > 1 &&
        country === "Brasil" && (
          <Select
            required
            name="installments"
            className="installments"
            onChange={selectInstallment}
            options={installmentsOptions}
            defaultValue={defaultValueSelectInstallment}
          />
        )}
    </InputContainer>
  );
};

export { WrapperInputs };
export default RadioCreditCard;
